import store from "@/store/store";

export const resetStore = () => {
  store.dispatch("resetState");
  store.dispatch("mail/resetState");
  store.dispatch("site/resetState");
  store.dispatch("domain/resetState");
  store.dispatch("modal/resetState");
};
